import React, { ReactElement, useEffect, useState } from 'react';
import { Toast } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { AlertOptions } from '../../../library/interfaces';
import { dismissAlert } from '../../../store/alerts/actions';
import { useIntercom } from 'react-use-intercom';
import { AlertEnums } from '../../../library/enums';

export default function Alert({ alert }: { alert: AlertOptions }): ReactElement {
  const dispatch = useDispatch();
  const [isIntercomShown, setIsIntercomShown] = useState(false);
  const { hide: hideIntercom, show: showIntercom } = useIntercom();
  const isGenericErrorMessage = alert.message.endsWith('contact support.');
  function handleOnClick() {
    if (isIntercomShown) {
      hideIntercom();
    } else {
      showIntercom();
      setShow(false);
      dispatch(dismissAlert(alert.id));
    }
    setIsIntercomShown(!isIntercomShown);
  }

  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);

  function removeAlert() {
    setShow(false);
    setTimeout(() => {
      dispatch(dismissAlert(alert.id));
    }, 100);
  }

  return (
    <Toast
      show={show}
      autohide={alert.autohide ? alert.autohide : true}
      delay={alert.dismissInMs ? alert.dismissInMs : 8000}
      onClose={removeAlert}
      className={alert.level === AlertEnums.INFO ? 'toast-info' : ''}
    >
      <Toast.Header closeButton className={'toast-header-custom'}>
        {alert.title}
      </Toast.Header>
      {isGenericErrorMessage ? (
        <Toast.Body>
          {alert.message.replace('contact support.', '')}
          <u onClick={handleOnClick} style={{ cursor: 'pointer' }}>
            contact support.
          </u>
        </Toast.Body>
      ) : (
        <Toast.Body>{alert.message}</Toast.Body>
      )}
    </Toast>
  );
}
